<sh-text class="text-align-left" p>
    <b class="text-align-center" *ngIf="showAcceptDecline"> Please accept the following terms and conditions </b>
     <br /> <br />
    I’m aware that all Information from Siemens Healthineers that is within the VAL may be used both, internally and
    externally as well as globally and also commercially.
    <br><br>
    Therefore I agree,
    <br><br>
    to only upload data, pictures, video or any other information to the VAL, for which legal restrictions apply
    neither content wise, time wise, nor region wise regarding e.g. copy right, contractual agreements or
    arrangements of confidentiality. In case of doubt I verified this with LEGAL and/or DP.
    <br>
    to use all data, pictures, video or any other information I download from the VAL only within the framework of
    my terms of employment with Siemens Healthineers.
    <br>
</sh-text>
<!-- <sh-button color='tertiary' slot='footer' label='Cancel' (click)="declineTerms()" *ngIf="showAcceptDecline"></sh-button>
<sh-button color='secondary' slot='footer' label='Accept' (click)="acceptTerms()" *ngIf="showAcceptDecline"></sh-button> -->